import React from "react";
import { motion } from "framer-motion";
import "./Banner.css";
import one from "./Apple Logo@2x.png";
import banner from "./final.png";
// import three from "./refresh@2x.png";
// import four from "./card@2x.png";

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.25,
      delay: i * 0.08,
      ease: "easeOut"
    }
  })
};

const Banner = () => {
  return (
    <div className="container pt-5 mt-5">
      <div className="row row-cols-lg-2 row-cols-1">
        {/* LEFT CONTENT */}
        <motion.div
          className="col-lg-6 col-12 text-center text-lg-start "
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          <motion.div
            custom={0}
            variants={fadeUp}
            className="notero-button btn mb-3 mt-md-5"
          >
            Your Perfect ISP Billing Solution
          </motion.div>

          <motion.h1 custom={1} variants={fadeUp} className="header-text">
            Welcome to <span className="text-color">Amar Net Bill</span>
          </motion.h1>

          <motion.h1 custom={2} variants={fadeUp} className="header-text lh-1">
            In One App{" "}
            <span className="text-color">Billing, Payments & Management</span>
          </motion.h1>

          <motion.p custom={3} variants={fadeUp} className="text-dark">
            The smart billing and payment app for ISPs and their clients. Simple
            setup, easy customization, and hassle-free payments — all in one
            app.
          </motion.p>

          <motion.div
            custom={4}
            variants={fadeUp}
            // className="row row-cols-1 row-cols-md-2 g-3"
          >
            {/* <div className="col"> */}
            <button className="downloadBtn rounded-pill">
              <div className="d-flex  text-center align-items-center ">
                <div className="down px-2">
                  <img className="tmg-fluid" src={one} alt="" />
                </div>
                <div>
                  <p className="mt-3 ">
                    {" "}
                    <span className="ps-3">|</span> Download App
                  </p>
                </div>
              </div>
            </button>
            {/* </div> */}
            {/* 
            <div className="col">
              <button className="downloadBtn rounded-pill">
                <div className="d-flex  text-center align-items-center ">
                  <div className="down px-2">
                    <FaPlay style={{ fontSize: "23px" }} />
                  </div>
                  <div>
                    <p className="mt-3 ">
                      {" "}
                      <span className="ps-3">|</span> Viw Promotion
                    </p>
                  </div>
                </div>
              </button>
            </div> */}
          </motion.div>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="col-lg-6 col-12 mt-5 mt-lg-0 text-center text-lg-center"
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            transition: { duration: 0.3, ease: "easeOut" }
          }}
          viewport={{ once: true }}
        >
          <img className="img-fluid mt-5 mt-md-0 " src={banner} alt="" />
          <div id="gol-red" className="d-none d-lg-block"></div>
        </motion.div>
      </div>
    </div>
  );
};

export default Banner;
